import { Phone } from "lucide-react";
import { useBrand } from "../context/BrandContext";

export const LongDistanceNote = ({ quote, compact = false, testid = "long-distance-note" }) => {
  const b = useBrand();
  if (!quote?.long_distance) return null;
  return (
    <div className={`border border-orange-300 border-l-4 border-l-amber-500 bg-orange-50 ${compact ? "p-2.5 mt-2" : "p-4 mt-4"}`} data-testid={testid}>
      <p className={`font-semibold text-slate-900 ${compact ? "text-xs" : "text-sm"}`}>{quote.long_distance_message || "Long distance? Call us to negotiate a better rate"}</p>
      <a href={`tel:${b.phone_tel}`} className={`btn-amber mt-2 w-full ${compact ? "h-8 text-[11px]" : "h-10 text-sm"}`} data-testid={`${testid}-call`}>
        <Phone className="w-3.5 h-3.5" />Call {b.phone_display}
      </a>
    </div>
  );
};
